import { Flow } from 'signup-constants/Flow';
import { getIntegrationFlowSteps } from '../integrations-flow/getIntegrationFlowSteps';
import { Step } from '../views/Step';
const SoftwareFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.Industry, Step.JobRole, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.HubletSelection],
  postAccountCreation: [Step.CrmExperienceLevel],
  postExistingAccountSelection: []
};
export const GenericFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.JobRole, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.HubletSelection],
  postAccountCreation: [Step.CrmExperienceLevel, Step.JobField],
  postExistingAccountSelection: []
};
const AcademyFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.JobField, Step.JobRole, Step.CompanyName, Step.CompanySize, Step.CompanyDomain],
  postAccountCreation: [],
  postExistingAccountSelection: []
};
const DeveloperFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.JobRole, Step.CompanyName],
  postAccountCreation: [],
  postExistingAccountSelection: []
};
const HubSpotForStartupsFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.CompanySize, Step.OptionalPhoneNumber, Step.HubletSelection],
  postAccountCreation: [Step.CrmExperienceLevel],
  postExistingAccountSelection: [Step.CompanySize, Step.OptionalPhoneNumber]
};
const NoSurveyFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection],
  postAccountCreation: [],
  postExistingAccountSelection: []
};
const DirectoryListingFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain],
  postAccountCreation: [Step.CompanySize, Step.PhoneNumber],
  postExistingAccountSelection: [Step.CompanySize, Step.PhoneNumber]
};
const PartnerFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.JobRole, Step.CompanyName, Step.CompanyDomain, Step.CompanySize, Step.OptionalPhoneNumber, Step.HubletSelection],
  postAccountCreation: [],
  postExistingAccountSelection: [Step.JobRole, Step.CompanySize, Step.OptionalPhoneNumber]
};
const StandaloneCmsPartnerFlowSteps = {
  preVerification: [Step.UnauthedPartnerUserError],
  postVerification: [],
  postAccountCreation: [],
  postExistingAccountSelection: [Step.CmsPartnerCompanyDomainAndName, Step.HubletSelection]
};
const UserFlowsSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name],
  postAccountCreation: [],
  postExistingAccountSelection: []
};
const CmsFreeFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.Industry, Step.JobRole, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.HubletSelection],
  postAccountCreation: [Step.CmsSignupIntent, Step.CmsBusinessMaturity],
  postExistingAccountSelection: []
};
export const FlowStepsMapping = {
  [Flow.Crm]: SoftwareFlowSteps,
  [Flow.Marketing]: SoftwareFlowSteps,
  [Flow.Sales]: SoftwareFlowSteps,
  // TODO: Productise after Inbound

  /*
  [Flow.Service]: ManagementLevelRolloutSoftwareFlowSteps,
  */
  [Flow.Service]: SoftwareFlowSteps,
  [Flow.Trial]: SoftwareFlowSteps,
  [Flow.CmsFree]: CmsFreeFlowSteps,
  [Flow.ClassroomTraining]: GenericFlowSteps,
  [Flow.AssetProvider]: GenericFlowSteps,
  [Flow.Purchase]: GenericFlowSteps,
  [Flow.Academy]: AcademyFlowSteps,
  [Flow.AcademyEmbedded]: AcademyFlowSteps,
  [Flow.Developers]: DeveloperFlowSteps,
  [Flow.CmsDevelopers]: DeveloperFlowSteps,
  [Flow.SolutionsProvider]: NoSurveyFlowSteps,
  [Flow.FbCrm]: NoSurveyFlowSteps,
  [Flow.DirectoryListing]: DirectoryListingFlowSteps,
  [Flow.HubspotForStartups]: HubSpotForStartupsFlowSteps,
  [Flow.HubSpotPartners]: PartnerFlowSteps,
  [Flow.Connect]: UserFlowsSteps,
  [Flow.StandaloneCmsPartner]: StandaloneCmsPartnerFlowSteps,
  [Flow.Integrations]: getIntegrationFlowSteps(),
  [Flow.ChatSpot]: UserFlowsSteps
};